import { useState } from "react";
import apiJurados from "../api/Jurados/api-jurados";
import { Jurado, initialValuesModelJurado, ProyectoJurado } from "../models/JuradosModel/jurados.model";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import getStorageUser from "../middlewares/GetStorageUser"

export const useInscribirHojaJurados = () => {
  const [jurado, setJurado] = useState<Jurado>(initialValuesModelJurado);
  const [proyectosJurado, setProyectosJurado] = useState<Array<ProyectoJurado>>([]);
  const [proyectosSeguimiento, setProyectosSeguimiento] = useState<any>([]);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  //console.log(stateredux);
  // agregado despues del push
  const [criteriosEvaluacion, setCriteriosEvaluacion] = useState<any>([]);

  const [messageNoJurado, setMessageNoJurado] = useState(false);
  const consultarJurado = async () => {
    const user = getStorageUser()
    let data = await apiJurados.getJuryByDocNumber(user.documento);
    
    if(!data){
      setMessageNoJurado(true)
      return;
    }

    setMessageNoJurado(false);
    // 
    // let data = await apiJurados.getJuryByDocNumber(1121911607);
    setJurado(data[0]);
    let data2 = await apiJurados.obtenerCriterioJurado(data[0].id_jurado);
    // console.log(data2, "estos son los criterios del jurado");
    setCriteriosEvaluacion(data2);
    let data3 = await apiConvocatorias.getLineaConvocatorias();
    // console.log(data3, "estas son las lineas")
    return setLineasConvocatorias(data3.data);
  };

  const consultarProyectosJurado = async () => {
    const user = getStorageUser()
    let data = await apiJurados.getJuryByDocNumber(user.documento);
    // console.log(data[1].asignado, "estos son mis proyectos", participante);
    setProyectosJurado(data[1].asignado);
    let data2 = await apiJurados.obtenerCriterioJurado(data[1].id_jurado);
    // console.log(data2, "estos son los criterios del jurado");
    setCriteriosEvaluacion(data2);
    let data3 = await apiConvocatorias.getLineaConvocatorias();
    // console.log(data3, "estas son las lineas")
    return setLineasConvocatorias(data3.data);
  }

  const consultarProyectoJuradoCriterioProyecto = async () => {


    // let data = await apiJurados.obtenerCriterioProyectoJurado(participante.idParticipante);
    const user = getStorageUser()
    let data = await apiJurados.obtenerCriterioProyectoJurado(user.documento);

    if (data.message) {
      return setProyectosSeguimiento([]);

    }
    return setProyectosSeguimiento(data.projectsall);

  }

  return {
    jurado,
    setJurado,
    proyectosJurado,
    consultarJurado,
    consultarProyectosJurado,
    consultarProyectoJuradoCriterioProyecto,
    criteriosEvaluacion,
    lineasConvocatorias,
    proyectosSeguimiento,
    messageNoJurado
  };
};
